interface WeatherInfo {
    name: string;
    icons: {
        day: string;
        night: string;
    };
}

interface WeatherCodes {
    [code: number]: WeatherInfo;
}

export interface WeatherDescription {
    description: string;
    icon: string;
}

const weather_codes: WeatherCodes = {
     0: {
          name: "Clear Sky",
          icons: {
               day: "clear.jpg",
               night: "clear-night.jpg"
          }
     },
     1: {
          name: "Mainly Clear",
          icons: {
               day: "clear.jpg",
               night: "clear-night.jpg"
          }
     },
     2: {
          name: "Partly Cloudy",
          icons: {
               day: "partly-cloudy.jpg",
               night: "partly-cloudy-night.jpg"
          }
     },
     3: {
          name: "Overcast",
          icons: {
               day: "overcast.jpg",
               night: "overcast.jpg"
          }
     },
     45: {
          name: "Fog",
          icons: {
               day: "fog.jpg",
               night: "fog-night.jpg"
          }
     },
     48: {
          name: "Rime Fog",
          icons: {
               day: "rime-fog.jpg",
               night: "rime-fog.jpg"
          }
     },
     51: {
          name: "Light Drizzle",
          icons: {
               day: "light-drizzle.jpg",
               night: "light-drizzle.jpg"
          }
     },
     53: {
          name: "Moderate Drizzle",
          icons: {
               day: "drizzle.jpg",
               night: "drizzle.jpg"
          }
     },
     55: {
          name: "Heavy Drizzle",
          icons: {
               day: "heavy-drizzle.jpg",
               night: "heavy-drizzle.jpg"
          }
     },
     56: {
          name: "Light Freezing Drizzle",
          icons: {
               day: "drizzle.jpg",
               night: "drizzle.jpg"
          }
     },
     57: {
          name: "Dense Freezing Drizzle",
          icons: {
               day: "heavy-drizzle.jpg",
               night: "heavy-drizzle.jpg"
          }
     },
     61: {
          name: "Slight Rain",
          icons: {
               day: "slight-rain.jpg",
               night: "slight-rain-night.jpg"
          }
     },
     63: {
          name: "Moderate Rain",
          icons: {
               day: "rain.jpg",
               night: "rain.jpg"
          }
     },
     65: {
          name: "Heavy Rain",
          icons: {
               day: "heavy-rain.jpg",
               night: "heavy-rain.jpg"
          }
     },
     66: {
          name: "Light Freezing Rain",
          icons: {
               day: "rain.jpg",
               night: "rain.jpg"
          }
     },
     67: {
          name: "Heavy Freezing Rain",
          icons: {
               day: "heavy-rain.jpg",
               night: "heavy-rain.jpg"
          }
     },
     71: {
          name: "Slight snowfall",
          icons: {
               day: "light-snow.jpg",
               night: "light-snow-night.jpg"
          }
     },
     73: {
          name: "Moderate snowfall",
          icons: {
               day: "snow.jpg",
               night: "snow.jpg"
          }
     },
     75: {
          name: "Heavy snowfall",
          icons: {
               day: "heavy-snow.jpg",
               night: "heavy-snow.jpg"
          }
     },
     77: {
          name: "Snow Grains",
          icons: {
               day: "snow-grains.jpg",
               night: "snow-grains.jpg"
          }
     },
     80: {
          name: "Slight Rain Showers",
          icons: {
               day: "slight-rain.jpg",
               night: "slight-rain-night.jpg"
          }
     },
     81: {
          name: "Moderate Rain Showers",
          icons: {
               day: "rain.jpg",
               night: "rain.jpg"
          }
     },
     82: {
          name: "Violent Rain Showers",
          icons: {
               day: "heavy-rain.jpg",
               night: "heavy-rain.jpg"
          }
     },
     85: {
          name: "Light Snow Showers",
          icons: {
             day: "light-snow.jpg",
            night: "light-snow-night.jpg"
          }
     },
     86: {
          name: "Heavy Snow Showers",
          icons: {
               day: "heavy-snow.jpg",
               night: "heavy-snow.jpg"
          }
     },
     95: {
          name: "Thunderstorm",
          icons: {
               day: "thunderstorm.jpg",
               night: "thunderstorm.jpg"
          }
     },
     96: {
          name: "Slight Hailstorm",
          icons: {
               day: "hail.jpg",
               night: "hail.jpg"
          }
     },
     99: {
          name: "Heavy Hailstorm",
          icons: {
               day: "heavy-hail.jpg",
               night: "heavy-hail.jpg"
          }
     },
};


export const getWeatherDescription = (weatherCode: number): WeatherInfo => {
    const weatherInfo = weather_codes[weatherCode];

    if (!weatherInfo) {
        return {
            name: 'Unknown',
            icons: {
                day: 'unknown.jpg',
                night: 'unknown.jpg'
            }
        };
    }
    return weatherInfo;
};

export const getWeatherIconPath = (weatherCode: number = 0, isDay: boolean = true): string => {
    const weatherInfo = getWeatherDescription(weatherCode);
    return isDay ? weatherInfo.icons.day : weatherInfo.icons.night;
};

export const getWeatherInfo = (weatherCode: number = 0, isDay: boolean = true): WeatherDescription => {
    const weatherInfo = getWeatherDescription(weatherCode);
    const icon = isDay ? weatherInfo.icons.day : weatherInfo.icons.night;
    return { description: weatherInfo.name, icon };
}

export const getWeatherIcon = (weatherCode: number = 0, isDay: boolean = true): string => {
    const weatherInfo = getWeatherDescription(weatherCode);
    const icon = isDay ? weatherInfo.icons.day : weatherInfo.icons.night;
    return icon;
}